module.exports = __webpack_public_path__ + "img/国家顶级节点标识首页_07.33eb885d.jpg";